export enum Alignment {
  COLUMN = "column",
  ROW = "row",
  GRID = "grid"
}
